<template>
    <div
        class="ds-preloader"
        :class="{ 'ds-preloader--round': round }"
        role="status"
    >
        <span v-if="round" class="ds-activity-indicator-large" />
        <span v-else-if="indicator" class="ds-activity-indicator" />
        <span v-else>
            <span
                v-for="preloaderItem in 4"
                :key="preloaderItem"
                class="ds-preloader-item"
            />
        </span>
    </div>
</template>
<script setup>
defineProps({
    round: {
        type: Boolean,
        required: false,
        default: false,
    },
    indicator: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>

<style scoped>
.ds-preloader {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ds-preloader-item {
  float: left;
  display: block;
  width: 0.5em;
  height: 0.5em;
  margin-right: 0.1em;
  margin-left: 0.1em;
  background-color: var(--color-base-black-default);
  border-radius: 50%;
  animation: pulse 1.2s infinite ease-in-out both;
  animation-direction: alternate;
  will-change: opacity, transform;
}
.ds-preloader-item:nth-child(1) {
  animation-delay: 0ms;
}
.ds-preloader-item:nth-child(2) {
  animation-delay: 120ms;
}
.ds-preloader-item:nth-child(3) {
  animation-delay: 240ms;
}
.ds-preloader-item:nth-child(4) {
  animation-delay: 360ms;
}

@keyframes pulse {
  0%, 80%, 100% {
    opacity: 0;
    transform: scale(0);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}
.ds-activity-indicator {
  animation: spin 0.6s linear infinite;
  border: 2px solid var(--color-base-grey-400);
  border-top: 2px solid var(--color-base-grey-800);
  border-radius: 50%;
  width: 1.25rem;
  height: 1.25rem;
}

.ds-activity-indicator-large {
  animation: spin 2s linear infinite;
  border: 10px solid var(--color-base-grey-200);
  border-top: 10px solid var(--color-primary-800);
  border-radius: 50%;
  width: 5.625rem;
  height: 5.625rem;
}
</style>
